// Build: 2025-11-03 23:59 - Fix order total display (total_cost→total_price) & force cache invalidation
// Import polyfills FIRST before anything else
import './polyfills'

import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

import { Provider } from 'react-redux'
import store from './redux/store'

// Antd 5 uses CSS-in-JS, no need to import CSS
// import 'antd/dist/antd.css' removed

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const root = createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <App />
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
